import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f359ab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = { class: "W-100 H-100 D-Flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = { class: "DialogSection FlexColumn" }
const _hoisted_9 = { class: "D-Flex W-100" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_11 = { class: "DialogSection" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_15 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_CookiesImageInput, {
                Folder: _ctx.API_URL.replaceAll('.', '_'),
                style: {"border-radius":"var(--rad1)","width":"12em","height":"12em"},
                Res: 'D_Branch_ImgUrl'
              }, null, 8, ["Folder"])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Name'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Branch_Name') && _ctx.MEMRead('D_Branch_Name') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Branch_Name') && _ctx.MEMRead('D_Branch_Name') !== ''),
              Res: 'D_Branch_Name',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Address'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Branch_Address') && _ctx.MEMRead('D_Branch_Address') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Branch_Address') && _ctx.MEMRead('D_Branch_Address') !== ''),
              Res: 'D_Branch_Address',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_CookiesNormalInput, {
                type: 'Number',
                Placeholder: _ctx.Translate('Postal Code'),
                CookiesInvalidInput: !(_ctx.MEMRead('D_Branch_PostalCode') && _ctx.MEMRead('D_Branch_PostalCode') !== ''),
                ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Branch_PostalCode') && _ctx.MEMRead('D_Branch_PostalCode') !== ''),
                Res: 'D_Branch_PostalCode',
                Default: ''
              }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
              _createVNode(_component_CookiesNormalInput, {
                type: 'Number',
                Placeholder: _ctx.Translate('Phone Number'),
                CookiesInvalidInput: !(_ctx.MEMRead('D_Branch_PhoneNumber') && _ctx.MEMRead('D_Branch_PhoneNumber') !== ''),
                ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Branch_PhoneNumber') && _ctx.MEMRead('D_Branch_PhoneNumber') !== ''),
                Res: 'D_Branch_PhoneNumber',
                Default: ''
              }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"])
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CookiesCheckBox, {
              Res: 'D_Branch_CustomIdentity',
              Name: _ctx.Translate('Custom Identity'),
              Type: 'Switch'
            }, null, 8, ["Name"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.MEMRead('D_Branch_CustomIdentity') ? '' : 'Disabled', "DialogSection"])
          }, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Legal Name'),
              style: {"width":"20em","max-width":"50vw"},
              LimitLines: 2,
              CustomStyle: 'max-height: 2.5em; min-height: 2.5em; overflow:hidden; resize: none;',
              Res: 'D_Branch_LegalName'
            }, null, 8, ["Placeholder", "CustomStyle"])
          ], 2),
          _hoisted_12,
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.MEMRead('D_Branch_CustomIdentity') ? '' : 'Disabled', "DialogSectionTitle"])
          }, _toDisplayString(_ctx.Translate('Branch Logo')), 3),
          _hoisted_13,
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.MEMRead('D_Branch_CustomIdentity') ? '' : 'Disabled', "DialogSection"])
          }, [
            _createElementVNode("label", {
              class: "LogoImageUpload Pointer Shadow1",
              style: _normalizeStyle('background-image: ' + 'url(' + _ctx.DefaultImageHandler(_ctx.MEMRead('D_Branch_Logo'), _ctx.$store.getters.DynamicConfig.Logo) + ')')
            }, [
              _createElementVNode("input", {
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.LogoChanged && _ctx.LogoChanged(...args))),
                name: "LogoImageUpload",
                class: "D-None",
                type: "file",
                accept: "image/*"
              }, null, 32)
            ], 4)
          ], 2)
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Branches_Edit': 'Branches_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Save')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}